import dayjs from "~/utils/dayjs";

/**
 * Renders a camera date/datetime column value in the org's format. The stores
 * write three shapes — kill date `YYYY-MM-DD`, photo date a bare `YYYYMMDD`
 * string, photo datetime `YYYY-MM-DD HH:mm:ss[.SSS]` — and dayjs's default
 * parser reads all three.
 *
 * Anything it cannot read falls back to the raw value: a cell reading "Invalid
 * Date" loses information the stored string still carries.
 */
export const formatDateValue = (
  value: unknown,
  format: string,
): string | undefined => {
  if (value === null || value === undefined || value === "") return undefined;

  const text = String(value);
  const parsed = dayjs(text);
  return parsed.isValid() ? parsed.format(format) : text;
};
